<template>
 <v-app>
    <v-main>
      <Loader v-if="$loading.value"></Loader>
      <v-layout column>
        <v-flex v-if="checkCabecalho()" style="background-color: #364f66;">
          <Header />
        </v-flex>
        <v-layout row wrap>
          <div class="main-container" :class="{ 'expanded': sidebarClosed }">
            <router-view :key="$route.fullPath" />
            <FooterPage />
          </div>
        </v-layout>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>

import Header from './components/PageHeader.vue'
import FooterPage from './components/PageFooter.vue'
import Loader from './components/PageLoader.vue'

export default {
  name: 'App',
  components: {
    Header,
    FooterPage,
    Loader
  },
  data: () => ({
    drawer: true,
    rail: true,
    sidebarClosed: false,
  }),
  methods: {
    checkCabecalho() {
      //console.log(this.$route.fullPath)
      if (this.$route.fullPath === '/' || this.$route.fullPath.includes('ResetSenha')) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
  },
}
</script>
<style>
@import "@/vendors/styles/core.css";
@import "@/vendors/styles/icon-font.min.css";
@import "@/vendors/styles/style.css";

:root {
  --app-bg: #f3f5f7;
  --app-surface: #ffffff;
  --app-surface-muted: #f8fafc;
  --app-border: #dbe2ea;
  --app-border-strong: #cbd5e1;
  --app-text: #172331;
  --app-muted: #64748b;
  --app-primary: #2f6f73;
  --app-primary-dark: #24585c;
  --app-secondary: #597899;
  --app-warning: #b88939;
}

html,
body,
#app,
.v-application {
  background: var(--app-bg) !important;
  color: var(--app-text);
  font-family: Inter, "Segoe UI", Roboto, Arial, sans-serif !important;
}

.v-main {
  background: var(--app-bg) !important;
}

.card-box,
.da-card,
.footer-wrap {
  background: var(--app-surface) !important;
  border: 1px solid var(--app-border) !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 30px rgba(15, 23, 42, .045) !important;
}

.card-header {
  background: transparent !important;
  border-bottom: 1px solid var(--app-border) !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: var(--app-text);
  letter-spacing: 0;
}

.text-blue,
.text-primary {
  color: var(--app-primary) !important;
}

.btn-primary,
.badge-primary,
.swal2-confirm {
  background-color: var(--app-primary) !important;
  border-color: var(--app-primary) !important;
}

.btn-success {
  background-color: var(--app-primary) !important;
  border-color: var(--app-primary) !important;
}

.v-field {
  --v-input-padding-top: 6px;
  background: #fff !important;
  border-radius: 8px !important;
}

.v-field--variant-outlined .v-field__outline {
  color: var(--app-border-strong) !important;
}

.v-field--focused .v-field__outline,
.v-field:hover .v-field__outline {
  color: var(--app-primary) !important;
}

.v-label {
  color: var(--app-muted) !important;
  font-weight: 600;
  letter-spacing: 0 !important;
}

.v-input {
  font-size: 14px;
}

.v-btn {
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.v-tab {
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.easy-data-table,
.vue3-easy-data-table,
.customize-table {
  border-radius: 8px !important;
  overflow: hidden;
}

@media (max-width:767px) {
  .hidden-xs {
    display: none !important;
  }

  .bordasEsp {
    padding-left: 15px;padding-right: 10px;padding-bottom: 10px;padding-top: 30px;
  }
}

@media (min-width:768px) and (max-width:991px) {
  .hidden-sm {
    display: none !important;
  }

  .bordasEsp {
    padding-left: 20px;padding-right: 10px;padding-bottom: 10px;padding-top: 30px;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .hidden-md {
    display: none !important;
  }

  .bordasEsp {
    padding-left: 40px;padding-right: 20px;padding-bottom: 10px;padding-top: 30px;
  }
}

@media (min-width:1200px) {
  .hidden-lg {
    display: none !important;
  }

  .bordasEsp {
    padding-left: 40px;padding-right: 20px;padding-bottom: 10px;padding-top: 30px;
  }
}


.main-container {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  background-color: var(--app-bg);
}

.v-label {
    align-items: center;
    display: inline-flex;
    font-size: 14px !important;
    letter-spacing: 0.009375em;
    min-width: 0;
    opacity: var(--v-medium-emphasis-opacity);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* ckeditor */
.ck.ck-editor__editable_inline {
  border:1px solid #cccccc !important;
  min-height: 100px;
}

/* ckeditor */


/* customiza datatables */

.customize-table {
  --easy-table-border: 1px solid #dbe2ea;
  --easy-table-row-border: 1px solid #e8eef4;

  --easy-table-header-font-size: 14px;
  --easy-table-header-height: 38px;
  --easy-table-header-font-color: #f8fafc;
  --easy-table-header-background-color: #2f6f73;

  --easy-table-header-item-padding: 10px 5px;

  --easy-table-body-even-row-font-color: #172331;
  --easy-table-body-even-row-background-color: #f8fafc;

  --easy-table-body-row-font-color: #172331;
  /*--easy-table-body-row-background-color: #2d3a4f;
  --easy-table-body-row-height: 50px;
  --easy-table-body-row-font-size: 14px;

  --easy-table-body-row-hover-font-color: #2d3a4f;
  --easy-table-body-row-hover-background-color: #eee;

  --easy-table-body-item-padding: 10px 15px;

  --easy-table-footer-background-color: #2d3a4f;
  --easy-table-footer-font-color: #c0c7d2;
  --easy-table-footer-font-size: 14px;
  --easy-table-footer-padding: 0px 10px;
  --easy-table-footer-height: 50px;

  --easy-table-rows-per-page-selector-width: 70px;
  --easy-table-rows-per-page-selector-option-padding: 10px;
  --easy-table-rows-per-page-selector-z-index: 1;


  --easy-table-scrollbar-track-color: #2d3a4f;
  --easy-table-scrollbar-color: #2d3a4f;
  --easy-table-scrollbar-thumb-color: #4c5d7a;;
  --easy-table-scrollbar-corner-color: #2d3a4f;

  --easy-table-loading-mask-background-color: #2d3a4f;
  
   <!--
   <template #item-player="{ player, avator, page }">
      <div class="player-wrapper">
        <img class="avator" :src="avator" alt="" />
        <a target="_blank" :href="page">{{ player }}</a>
      </div>
    </template>
    <template #item-team="{ teamName, teamUrl }">
      <a target="_blank" :href="teamUrl">{{ teamName }}</a>
    </template>
    <template #item-operation="item">
      <div class="operation-wrapper">
          <img
          src="./images/delete.png"
          class="operation-icon"
          @click="deleteItem(item)"
          />
          <img
          src="./images/edit.png"
          class="operation-icon"
          @click="editItem(item)"
          />
      </div>
      </template>

                  /*{ text: "Id", value: "grtId",fixed: true, width: 40 }, -- congela coluna*/
             /*{ text: "Id", value: "grtId",sortable: true, width: 200 }, -- ordenação coluna

                     // formattedDate (value) {
        //    return this.$moment(value).format('DD/MM/YYYY')
        // }

        //import moment from 'moment'
    -->
  
  */
}

/* customiza datatables */
</style>
